import React, { useEffect, useRef, useState } from "react";
import { Link, Prompt, useHistory, useParams } from "react-router-dom";
import { ColorRender } from "../../systemadministration/usermanagement/CheckRole";
import { InitialRender, isBlockedNumericKey } from "../../common/Helper";
import { TrimText } from "../../common/TrimText";
import { RenderQuizAttemptResultStatus } from "../../../utils/CommonStatusItems";
import Hover from "../../common/Hover";
import { IMAGE_URL, STUDENT_FILE_DOWNLOAD, TABLE_ROWS_PER_PAGE, downloadURL } from "../../../utils/Constants";
import PermissionsGate from "../../../utils/permissionGate";
import {
  getCourseAssessment,
  getIntakeGradebook,
  updateGradeBookCousesScore,
} from "../../../services/GradeSettingService";
import SkeletonTicketList from "../../../loaders/SkeletonTicketList";
import Swal from "sweetalert2";
import Str from "../../common/Str";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import JsPDF from "jspdf";
import "jspdf-autotable";
import GradeBookSaveBar from "../../common/GradeBookSaveBar";
import ExcelJS from 'exceljs';
import { RenderLearningMethodGradebook } from "../../../utils/CommonGroupingItem";
import JSZip from 'jszip';
import { isAssessmentPending, options, twoDecimalRound } from "../../../utils/commonFunction";
import { usePermissionGuardRedirect } from "../../../hooks/usePermissionGuard";

function CourseGradeBook(props) {
  const { id } = useParams();
  const history = useHistory();
  const [search, setSearch] = useState("");
  const [debouncedTerm, setDebouncedTerm] = useState("");
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState({ list: false, heading: false });
  const [assessmentHeader, setAssessmentHeader] = useState([]);
  const [updateData, setUpdateData] = useState(false);
  const [percentageView, setPercentageView] = useState(false);
  const [excludeEmpty, setExcludeEmpty] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [paginationState, setPaginationState] = useState({
    total: 0,
    perPage: 0,
    currentPage: 0,
    lastPage: 0,
  });
  const [tableState, setTableState] = useState({ page: 1, limit: 10 });
  const [errorMessage, setErrorMessage] = useState("");
  const [tooltipValues, setTooltipValues] = useState();
  const [oldValue, setOldValue] = useState();
  const [tableWidth, setTableWidth] = useState(0);
  const [saveGradesLoading, setSaveGradesLoading] = useState(false);
  const [updateValueArr, setUpdateValueArr] = useState([]);
  const [isCourseEdited, setIsCourseEdited] = useState(0);
  const handleSaveGradesRef = useRef(null);
  const navigationPromptOpenRef = useRef(false);
  const skipCourseEditedRef = useRef(false);

  usePermissionGuardRedirect(['cagbview']);
  useEffect(() => {
    if (props.gradingStandard == 2) {
      history.push("/noaccess")
    }
  }, [props])

  useEffect(() => {
    const handleSwallActive = (event) => {
      checkbtnValue(event.detail);
    };
    window.addEventListener('swallActive', handleSwallActive);
    return () => {
      window.removeEventListener('swallActive', handleSwallActive);
    };
  }, []);

  const checkbtnValue = (saveAction) => {
    if (saveAction.type === 'saveAll' && handleSaveGradesRef.current) {
      handleSaveGradesRef.current();
    } else if (saveAction.type === 'save' && handleSaveGradesRef.current) {
      handleSaveGradesRef.current(saveAction.stdId);
    }
    Swal.close();
  };

  const shouldBlockNavigation = updateValueArr.length;

  const handleNavigation = (location, page, states) => {
    if (shouldBlockNavigation) {
      if (Swal.isVisible() || navigationPromptOpenRef.current) {
        return false;
      }
      navigationPromptOpenRef.current = true;
      Swal.fire({
        title: "Warning",
        text: "You Have Unsaved Changes Left! Do you want to save changes",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "No, Leave",
        confirmButtonText: "Yes, Save Changes",
      }).then((value) => {
        navigationPromptOpenRef.current = false;
        if (value.isConfirmed) {
          if (saveGradesLoading) {
            return;
          }
          setSaveGradesLoading(true);
          Swal.fire({
            title: "Please wait",
            text: "Saving changes...",
            allowOutsideClick: false,
            onBeforeOpen: () => {
              Swal.showLoading();
              const values = {
                intake_id: id,
                assessment: updateValueArr,
              };
              updateGradeBookCousesScore(values)
                .then((res) => {
                  setSaveGradesLoading(false);
                  setUpdateValueArr([]);
                  setIsCourseEdited(0);
                  Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: "Updated Successfully",
                  }).then(() => {
                    if (location) {
                      history.push(location.pathname)
                    } else if (!location && page) {
                      if (page == "exempted") {
                        handleExemption(...states)
                      } else {
                        setTableState((prevState) => ({
                          ...prevState,
                          page:
                            page === "firstPage"
                              ? 1
                              : page === "prevPage"
                                ? paginationState.currentPage - 1
                                : page === "nextPage"
                                  ? +paginationState.currentPage + 1
                                  : paginationState.lastPage,
                        }));
                      }
                    }
                  });
                })
                .catch((err) => {
                  setSaveGradesLoading(false);
                  Swal.close(); // Close the "Saving changes..." popup if there was an error
                  Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: `${err?.response?.data?.data}`,
                  });
                });
            },
          });
        } else {
          setUpdateValueArr([]);
          if (location) {
            history.push(location.pathname)
          } else if (!location && page) {
            if (page == "exempted") {
              handleExemption(...states)
            } else {
              setTableState((prevState) => ({
                ...prevState,
                page:
                  page === "firstPage"
                    ? 1
                    : page === "prevPage"
                      ? paginationState.currentPage - 1
                      : page === "nextPage"
                        ? +paginationState.currentPage + 1
                        : paginationState.lastPage,
              }));
            }
          }
        }
      });

      return false; // Prevent the default navigation behavior
    } else if (page == "exempted") {
      handleExemption(...states)
    }
  };


  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (shouldBlockNavigation) {
        event.preventDefault();
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [shouldBlockNavigation]);

  useEffect(() => {
    setLoading((prevState) => ({ ...prevState, heading: true }));
    getCourseAssessment(id)
      .then((res) => {
        setAssessmentHeader(res.data?.assessment);
        setExcludeEmpty(res.data?.exclude_empty_grades); 
        setLoading((prevState) => ({ ...prevState, heading: false }));
      })
      .catch((err) => {
        console.error("error", err);
        setLoading((prevState) => ({ ...prevState, heading: false }));
      });
  }, []);

  useEffect(() => {
    setLoading((prevState) => ({ ...prevState, list: true }));
    const Values = {
      intake_id: id,
      key: "",
      sort: "DESC",
      exportStatus: "false",
      search: search,
      page: tableState.page,
      limit: tableState.limit,
    };
    getIntakeGradebook(Values)
      .then((res) => {
        if (skipCourseEditedRef.current) {
          skipCourseEditedRef.current = false;
          setIsCourseEdited(0);
        } else {
          setIsCourseEdited(res?.data?.getCourse?.allUpdatedCourse);
        }
        setUserData(res?.data?.result?.data?.map(item => ({ ...item, isDis: true, isSupplementary: item.assessmentArr.some((supplement) => supplement.isSupplementaryForThisStudent && !supplement.isSickForThisStudent) })));
        setPaginationState({
          total: res?.data?.result?.total,
          perPage: res?.data?.result?.perPage,
          currentPage: res?.data?.result?.page,
          lastPage: res?.data?.result?.lastPage,
        });
        setTooltipValues(res?.data?.getCourse);
        setLoading((prevState) => ({ ...prevState, list: false }));
      })
      .catch((err) => {
        console.error(err);
        setLoading((prevState) => ({ ...prevState, list: false }));
      });
  }, [updateData, id, tableState, search]);

  useEffect(() => {
    let timeOut = setTimeout(() => {
      setSearch(debouncedTerm);
    }, 1000);

    return () => {
      clearTimeout(timeOut);
    };
  }, [debouncedTerm]);

  const handleSearchFilter = (e) => {
    const value = e.target.value;
    setDebouncedTerm(value);
  };

  const resetFilter = () => {
    setDebouncedTerm("");
  };

  const handleExemption = (assId, stdId, val, gradeType, grade, is_marked) => {

    let updateArray = [...updateValueArr];

    const existingIndex = updateArray.findIndex(
      (item) => item.assessment_id === assId && item.student_id === stdId
    );

    if (existingIndex !== -1) {
      let obj = {
        ...updateArray[existingIndex],
        student_id: stdId,
        grade_type: gradeType,
        grant_exemption: val
      };
      updateArray[existingIndex] = obj
    } else {
      updateArray.push({
        student_id: stdId,
        assessment_id: assId,
        grade_type: gradeType,
        grade: grade >= 0 ? grade : "",
        grant_exemption: val
      });
    }

    let updateUserData = userData
    const studentIndex = updateUserData.findIndex(
      (studentRecord) => studentRecord.student_id === stdId
    );
    if (studentIndex !== -1) {
      const assessmentIndex = updateUserData[studentIndex].assessmentArr.findIndex(
        (assessmentRecord) => assessmentRecord.assessment_id === assId
      );
      if (assessmentIndex !== -1) {
        updateUserData[studentIndex].assessmentArr[assessmentIndex].grant_exemption = val;
      }
    }

    setUserData([...updateUserData])
    setUpdateValueArr([...updateArray])
  };

  const handleUpdateMarks = (stdId, assId, gradeType, grade, maxMark) => {
    if (grade === oldValue) {
      setOldValue();
      return;
    }
    if (
      (grade > maxMark && gradeType == "3") ||
      (gradeType == "0" && grade > maxMark)
    ) {
      setErrorMessage("Sorry you can't put mark more then Total mark");
      return;
    }
    setErrorMessage("");

    let updateArray = [...updateValueArr];

    const existingIndex = updateArray.findIndex(
      (item) => item.assessment_id === assId && item.student_id === stdId
    );

    if (existingIndex !== -1) {
      updateArray[existingIndex] = {
        ...updateArray[existingIndex],
        student_id: stdId,
        grade_type: gradeType,
        grade: grade >= 0 ? grade : "",
      };
    } else {
      updateArray.push({
        student_id: stdId,
        assessment_id: assId,
        grade_type: gradeType,
        grade: grade >= 0 ? grade : "",
      });
    }

    let tempArr = userData;
    let isdisabledcheck = tempArr.map((item) => {
      if (item.student_id === stdId) {
        return { ...item, isDis: false };
      }
      return { ...item };
    });
    setUserData(isdisabledcheck);
    setUpdateValueArr(updateArray);
  };

  const handleDownloadMarkerFiles = async (student_id, assessment_id) => {
    const student = userData.find((student) => student.student_id === student_id);

    if (!student) {
      alert('Student not found.');
      return;
    }

    const assessment = student.assessmentArr.find((ass) => ass.assessment_id === assessment_id);

    if (!assessment) {
      alert('Assessment not found for the selected student.');
      return;
    }

    if (assessment.return && assessment.return.length > 0) {
      if (assessment.return.length === 1) {
        // Only one file, download it directly
        const markerFile = assessment.return[0];
        try {
          const response = await fetch(`${downloadURL + STUDENT_FILE_DOWNLOAD}/${encodeURI(markerFile.replace("public/", "").replaceAll("/home/myaie/public_html/", ""))}`);
          const blob = await response.blob();

          const downloadLink = document.createElement('a');
          downloadLink.href = URL.createObjectURL(blob);
          downloadLink.download = markerFile.split('/').pop();
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        } catch (error) {
          console.error('Error downloading marker file:', error);
        }
      } else {
        // Multiple files, create a zip
        const zip = new JSZip();
        const downloadPromises = assessment.return.map(markerFile =>
          fetch(`${downloadURL + STUDENT_FILE_DOWNLOAD}/${encodeURI(markerFile.replace("public/", "").replaceAll("/home/myaie/public_html/", ""))}`)
            .then(response => response.blob())
            .then(blob => {
              const fileName = markerFile.split('/').pop();
              zip.file(fileName, blob);
            })
        );

        try {
          await Promise.all(downloadPromises);
          const content = await zip.generateAsync({ type: 'blob' });
          const downloadLink = document.createElement('a');
          downloadLink.href = URL.createObjectURL(content);
          downloadLink.download = `${student.full_name}_MarkerFiles.zip`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        } catch (error) {
          console.error('Error downloading marker files:', error);
        }
      }
    } else {
      alert('Marker files not found for the selected assessment.');
    }
  };

  const exportData = (fileType, fileName) => {
    const Values = {
      intake_id: id,
      key: "",
      sort: "DESC",
      exportStatus: "true",
      search: search,
      page: tableState.page,
      limit: tableState.limit,
    };
    Swal.fire({
        title: "File downloading",
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: () => {
          Swal.showLoading();
       },
    })
    getIntakeGradebook(Values)
      .then((res) => {
        const respData = res?.data?.result?.data;
        const header = [
          "Student Name",
          "Student Number",
          "Assessment Name",
          "Assessment Grade",
          "Assessment Result",
          "Course Grade",
          "Course Result",
        ];
        const data = [];
        respData.map((item) => {
          let dataItem = {
            "Student Name": `${item.full_name}`,
            "Student Number": item?.student_num
              ? item?.student_num
              : item?.student_crm_id,
            "Assessment Name": "",
            "Assessment Grade": "",
            "Assessment Result": "",
            "Course Grade": percentageView
              ? (item?.scoreRecieved && item?.scoreRecieved != "N/A") ||
                item?.scoreRecieved === 0
                ? typeof item?.scoreRecieved == "string" &&
                  item?.scoreRecieved.includes("%")
                  ? Math.round(
                    parseFloat(item?.scoreRecieved.replace("%", ""))
                  ).toString() + "%"
                  : typeof item?.scoreRecieved == "string" &&
                    !item?.scoreRecieved.includes("%")
                    ? Math.round(parseFloat(item?.scoreRecieved)).toString() + "%"
                    : item?.scoreRecieved
                      ? item?.scoreRecieved
                      : "N/A"
                : "N/A"
              : item.grading_type != 3
                ? typeof item?.gradeText == "string" &&
                  item?.gradeText.includes("%")
                  ? Math.round(
                    parseFloat(item?.gradeText.replace("%", ""))
                  ).toString() + "%"
                  : item?.gradeText
                    ? item?.gradeText
                    : "N/A"
                : twoDecimalRound(item?.getAssessmentCalculate_sum_ass_mark) +
                " / " +
                item.getAssessmentCalculate_sum_ass_total_mark,
            "Course Result":
              item?.pass_status == "N/A"
                ? "N/A"
                : RenderQuizAttemptResultStatus(item?.pass_status).text,
          };
          data.push(dataItem);
          item.assessmentArr &&
            item.assessmentArr.map((row, index) => {
              let subDataItem = {
                "Student Name": "",
                "Student Number": "",
                "Assessment Name": assessmentHeader[index]?.name,
                "Assessment Grade": row?.grant_exemption
                  ? "Exempted"
                  : percentageView
                    ? row?.ass_percentage + "%"
                    : row?.grading_type == "0"
                      ? row?.ass_percentage + "%"
                      : row?.grading_type == "3"
                        ? `${row?.ass_mark}/${row?.ass_total_mark}`
                        : row?.gradeText,
                "Assessment Result":
                  row?.assessmentMarkingStatus?.toString() !==
                    "NOT SUBMITTED" && row.ass_total_mark
                    ? RenderQuizAttemptResultStatus(row.pass_status).text
                    : "N/A",
                "Course Grade": "",
                "Course Result": "",
              };
              data.push(subDataItem);
            });
        });
        if (fileType === "csv") {
          const csvString = Papa.unparse({ fields: header, data });
          const blob = new Blob([csvString], {
            type: "text/csv;charset=utf-8,",
          });

          const blobURL = window.URL.createObjectURL(blob);

          const anchor = document.createElement("a");
          anchor.download = fileName;
          anchor.href = blobURL;
          anchor.dataset.downloadurl = [
            "text/csv",
            anchor.download,
            anchor.href,
          ].join(":");
          anchor.click();

          setTimeout(() => {
            URL.revokeObjectURL(blobURL);
          }, 1000);
          Swal.close();
        } else if (fileType === "xlsx") {
          const compatibleData = data.map((row) => {
            const obj = {};
            header.map((col, index) => {
              obj[col] = row[col];
            });
            return obj;
          });

          let wb = XLSX.utils.book_new();
          let ws1 = XLSX.utils.json_to_sheet(compatibleData, { header });
          XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
          XLSX.writeFile(wb, `${fileName}.xlsx`);
          Swal.close();
          return false;
        }
        if (fileType === "pdf") {
          const compatibleData = data.map((row) => {
            return [
              row["Student Name"],
              row["Student Number"],
              row["Assessment Name"],
              row["Assessment Grade"],
              row["Assessment result"],
              row["Course Grade"],
              row["Course Result"],
            ];
          });
          const doc = new JsPDF();
          doc.autoTable({
            head: [header],
            body: compatibleData,
            styles: {
              minCellHeight: 10,
              minCellWidth: 5,
              halign: "left",
              fontSize: 8,
            },
          });
          doc.save(`${fileName}.pdf`);
          Swal.close();
          return false;
        }
      })
      .catch((err) => console.error(err));
  };

  const exportXlsxData = async (fileName, courseName) => {
    try {
      const Values = {
        intake_id: id,
        key: "",
        sort: "DESC",
        exportStatus: "true",
        search: search,
        page: tableState.page,
        limit: tableState.limit,
      };
      // add swall loading here
      Swal.fire({
        title: "File downloading",
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: () => {
          Swal.showLoading();
        },
      })
      const res = await getIntakeGradebook(Values);
      const respData = res?.data?.result;
      let learning_method = res?.data?.getCourse?.type
      const header = [
        "Name",
        "Surname",
        "ID Number",
        "Student Number",
        "Study Method",
        ...assessmentHeader.map((assessment) => assessment?.name),
        "Final Mark",
      ];

      const data = respData.flatMap((item) => {
        const rowData = [
          item.first_name,
          item.last_name,
          item?.number ? item?.number : " ",
          item?.student_crm_id ? item?.student_crm_id : item?.student_num ? item?.student_num : " ",
          learning_method ? RenderLearningMethodGradebook(learning_method).text : " ",
          ...assessmentHeader.map((assessment) => {
            const assessmentData = item.assessmentArr.find(
              (row) => row.assessment_id === assessment?.id
            );
            if (assessmentData) {
              return assessmentData?.grant_exemption ? "Exempted"
                : percentageView
                  ? assessmentData?.ass_percentage + "%"
                  : assessmentData?.grading_type == "0"
                    ? assessmentData?.ass_percentage + "%"
                    : assessmentData?.grading_type == "3"
                      ? `${assessmentData?.ass_mark}/${assessmentData?.ass_total_mark}`
                      : assessmentData?.gradeText;
            }
            return "";
          }),
          percentageView
            ? (item?.scoreRecieved && item?.scoreRecieved != "N/A") ||
              item?.scoreRecieved === 0
              ? typeof item?.scoreRecieved == "string" &&
                item?.scoreRecieved.includes("%")
                ? Math.round(
                  parseFloat(item?.scoreRecieved.replace("%", ""))
                ).toString() + "%"
                : typeof item?.scoreRecieved == "string" &&
                  !item?.scoreRecieved.includes("%")
                  ? Math.round(parseFloat(item?.scoreRecieved)).toString() + "%"
                  : item?.scoreRecieved
                    ? item?.scoreRecieved
                    : "N/A"
              : "N/A"
            : item.grading_type != 3
              ? typeof item?.gradeText == "string" &&
                item?.gradeText.includes("%")
                ? Math.round(
                  parseFloat(item?.gradeText.replace("%", ""))
                ).toString() + "%"
                : item?.gradeText
                  ? item?.gradeText
                  : "N/A"
              : item?.getAssessmentCalculate_sum_ass_mark +
              " / " +
              item.getAssessmentCalculate_sum_ass_total_mark,
        ];
        return [rowData];
      });


      const wb = new ExcelJS.Workbook();
      const ws = wb.addWorksheet('Excel Data');

      ws.views = [
        {
          state: 'frozen',
          ySplit: 1,
          xSplit: 1
        },
      ];
      ws.properties.showGridLines = true;

      const columnStyles = [];
      header.forEach((col) => {
        const style = {};
        if (['Name', 'Surname', 'ID Number', 'Student Number', 'Study Method'].includes(col)) {
          style.font = { bold: true };
          style.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFDBDBDB' }, // Light gray background color
          };
          style.border = {
            top: { style: 'thin', color: { argb: 'FF000000' } },
            bottom: { style: 'thin', color: { argb: 'FF000000' } },
            left: { style: 'thin', color: { argb: 'FF000000' } },
            right: { style: 'thin', color: { argb: 'FF000000' } }
          };
        } else if (col === 'Final Mark') {
          style.font = { color: { argb: "FFFFFF" } };
          style.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FF7030A0' }, // Purple background color
          };
          style.border = {
            top: { style: 'thin', color: { argb: 'FF000000' } },    // Black top border
            bottom: { style: 'thin', color: { argb: 'FF000000' } }, // Black bottom border
            left: { style: 'thin', color: { argb: 'FF000000' } },   // Black left border
            right: { style: 'thin', color: { argb: 'FF000000' } }   // Black right border
          };
        } else {
          style.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFDBDBDB' }, // Light gray background color
          };
          style.border = {
            top: { style: 'thin', color: { argb: 'FF000000' } },
            bottom: { style: 'thin', color: { argb: 'FF000000' } },
            left: { style: 'thin', color: { argb: 'FF000000' } },
            right: { style: 'thin', color: { argb: 'FF000000' } }
          };
        }
        columnStyles.push(style);
      });
      const staticRow = ws.addRow([courseName, '', '', '', '']);
      staticRow.height = 16;
      staticRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF66CCFF' } };
      staticRow.getCell(1).font = { bold: true };
      staticRow.getCell(1).alignment = { horizontal: 'center', vertical: "bottom" };
      staticRow.getCell(1).border = {};
      staticRow.getCell(5).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF203764' } };

      ws.mergeCells(`A${staticRow.number}:D${staticRow.number}`);


      const headerRow = ws.addRow(header);
      headerRow.eachCell((cell, colNumber) => {
        if (columnStyles[colNumber - 1].font) {
          cell.font = columnStyles[colNumber - 1].font;
        }
        cell.fill = columnStyles[colNumber - 1].fill;
        cell.border = columnStyles[colNumber - 1].border;
      });

      data.forEach((row) => {
        const dataRow = ws.addRow(row);
        dataRow.eachCell((cell, colNumber) => {
          cell.border = columnStyles[colNumber - 1].border;
        });
      });

      const buffer = await wb.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = `${fileName}.xlsx`;
      a.click();

      Swal.close();
    } catch (err) {
      console.error(err);
    }
  };

  const getPaginationRange = () => {
    if (!paginationState) return "0-0";
    const { currentPage = 1, perPage = 10, total = 0 } = paginationState;

    const start = perPage > 0 ? (currentPage - 1) * perPage + 1 : 0;
    const end = Math.min(currentPage * perPage, total);
    return `${start}-${end}`;
  };

  const slider = document.querySelector(".table-book-mid");

  useEffect(() => {
    if (slider) {
      let mouseDown = false;
      let startX, scrollLeft;

      let startDragging = function (e) {
        mouseDown = true;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      };
      let stopDragging = function (event) {
        mouseDown = false;
      };

      slider.addEventListener("mousemove", (e) => {
        e.preventDefault();
        if (!mouseDown) {
          return;
        }
        const x = e.pageX - slider.offsetLeft;
        const scroll = x - startX;
        slider.scrollLeft = scrollLeft - scroll;
      });

      // Add the event listeners
      slider.addEventListener("mousedown", startDragging, false);
      slider.addEventListener("mouseup", stopDragging, false);
      slider.addEventListener("mouseleave", stopDragging, false);
    }
  }, [slider]);

  const handleResize = () => {
    let pageWidth = document.querySelector(
      ".my-tickets-info-list"
    )?.offsetWidth;
    setTableWidth(pageWidth);
  };

  useEffect(() => {
    var resizeRequested = false;
    handleResize();
    window.addEventListener(
      "resize",
      function () {
        if (!resizeRequested) {
          resizeRequested = true;
          window.requestAnimationFrame(function () {
            setTableWidth(
              document.querySelector(".my-tickets-info-list")?.clientWidth
            );
            resizeRequested = false;
          });
        }
      },
      100
    );
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleWidth = () => {
    const leftTable = document.querySelector(".table-book-left");
    const midTable = document.querySelector(".table-book-mid");
    const midTableInner = midTable.querySelector(".grade-acc-in");
    const rightTable = document.querySelector(".table-book-right");

    if (!leftTable || !midTable || !midTableInner || !rightTable) return;

    // Calculate total available width for the middle table
    const leftTableWidth = leftTable.offsetWidth;
    const rightTableWidth = rightTable.offsetWidth;
    const availableWidth = tableWidth - leftTableWidth - rightTableWidth;

    const midCols = midTableInner.querySelectorAll("th, td");
    const colCount = midTableInner.querySelectorAll("thead th").length || 1;

    // No middle columns (empty middle table)
    if (midCols.length === 0) {
      midTable.style.width = availableWidth + "px";
      midTableInner.style.width = availableWidth + "px";
      midTable.style.overflowX = "hidden";

      const lastTableClass = rightTable.firstChild.className;
      const firstTableClass = leftTable.firstChild.className;
      if (!lastTableClass.includes("border-shadow-custom-table")) {
        rightTable.firstChild.className = `${lastTableClass} border-shadow-custom-table`;
      }
      if (!firstTableClass.includes("border-shadow-custom-table")) {
        leftTable.firstChild.className = `${firstTableClass} border-shadow-custom-table`;
      }
      return;
    }

    // Step 1: Get the width of all columns except the last one
    let totalOtherColsWidth = 0;
    midCols.forEach((col, index) => {
      if (index < colCount - 1) {
        const colStyle = window.getComputedStyle(col);
        const colWidth = col.offsetWidth
          + parseFloat(colStyle.paddingLeft)
          + parseFloat(colStyle.paddingRight)
          + parseFloat(colStyle.borderLeftWidth)
          + parseFloat(colStyle.borderRightWidth);
        totalOtherColsWidth += colWidth;
      }
    });

    // Step 2: Calculate remaining space for the last column
    let remainingWidth = availableWidth - totalOtherColsWidth;

    // Step 3: Ensure last column does not shrink below its natural width
    const lastCol = midCols[colCount - 1];
    if (lastCol) {
      const lastColNaturalWidth = lastCol.scrollWidth;
      lastCol.style.width = Math.max(lastColNaturalWidth, remainingWidth) + 12 + "px";
      lastCol.style.minWidth = Math.max(lastColNaturalWidth, remainingWidth) + 12 + "px";
    }

    // Step 4: Set middle table width as sum of all columns
    const totalMidWidth = totalOtherColsWidth + (lastCol ? lastCol.offsetWidth : 0);
    midTable.style.width = totalMidWidth + "px";
    midTableInner.style.width = totalMidWidth + "px";
    midTable.style.overflowX = "hidden";

    // Step 5: Apply shadow classes to left and right tables
    const lastTableClass = rightTable.firstChild.className;
    const firstTableClass = leftTable.firstChild.className;
    if (!lastTableClass.includes("border-shadow-custom-table")) {
      rightTable.firstChild.className = `${lastTableClass} border-shadow-custom-table`;
    }
    if (!firstTableClass.includes("border-shadow-custom-table")) {
      leftTable.firstChild.className = `${firstTableClass} border-shadow-custom-table`;
    }
  };

  let firstLoaded = true;
  useEffect(() => {
    if (userData?.length && tableWidth) {
      if (firstLoaded) {
        setTimeout(() => {
          handleWidth();
          firstLoaded = false;
        }, 500);
      } else {
        handleWidth();
      }
    }
  }, [userData, tableWidth,percentageView]);

  // Handle window resize for responsive behavior
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [percentageView]);

  const handleSaveGrades = (studentID) => {
    if (saveGradesLoading) {
      return;
    }

    const assessment = studentID
      ? updateValueArr.filter((studentAssessment) => studentAssessment.student_id == studentID)
      : updateValueArr;

    const shouldCalculateFinalTotals = !studentID && isCourseEdited;

    if (!assessment.length && !shouldCalculateFinalTotals) {
      return;
    }

    setSaveGradesLoading(true);
    Swal.fire({
      title: "Updating",
      onOpen: function () {
        Swal.showLoading();
      },
    });
    const values = {
      intake_id: id,
      assessment: assessment,
      student_id: studentID,
    };
    if (!studentID) {
      delete values.student_id;
    }
    updateGradeBookCousesScore(values)
      .then((res) => {
        setSaveGradesLoading(false);
        setUpdateValueArr([]);
        if (studentID) {
          skipCourseEditedRef.current = true;
        }
        setIsCourseEdited(0);
        Swal.close();
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Updated Successfully",
        }).then((res) => setUpdateData(!updateData));
      })
      .catch((err) => {
        setSaveGradesLoading(false);
        Swal.close();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `${err?.response?.data?.data}`,
        });
      });
  };

  handleSaveGradesRef.current = handleSaveGrades;

  const handleSaveSingleGrade = (stdId) => {
    const otherStudentUpdates = updateValueArr.filter(
      (studentAssessment) => studentAssessment.student_id !== stdId
    );
    if (otherStudentUpdates.length) {
      Swal.fire({
        title: "Are You Sure?",
        text: "You have unsaved data in other students",
        icon: "warning",
        showCancelButton: false,
        showConfirmButton: false,
        html: `
          <div class="custom-swal-button">
            <p>You have unsaved data in other students!</p>
            <button class="swal2-confirm swal2-styled" onclick='triggerSwall({type: "saveAll", updatedArr: ${JSON.stringify(
          updateValueArr
        )}})' >Save All</button>
            <button class="swal2-confirm swal2-styled" onclick='triggerSwall({type: "save", stdId: ${stdId}, updatedArr: ${JSON.stringify(
          updateValueArr
        )}})'>Save</button>
            <button class="swal2-cancel swal2-styled" onclick="triggerSwall({type: 'cancel'})" style="background-color: rgb(221, 51, 51);">Cancel</button>
          </div>`,
      });
    } else {
      handleSaveGrades(stdId);
    }
  };

  return (
    <>
      <Prompt when={!!shouldBlockNavigation} message={handleNavigation} />
      <div className="my-tickets-info-list Tickets-main-wrap course-gradebook">
        <div className="l-o-c-t custom-table-div filter-search-icon card card-table-custom">
          <div className="search-filter-div">
            <div className="search-filter-div-left">
              <div className="system-administration-table table-responsive">
                <div className="table-responsive-div">
                  <div
                    id="assessment-table-main_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <div
                      id="assessment-table-main_filter"
                      className="dataTables_filter"
                    >
                      <label>
                        <input
                          type="search"
                          className=""
                          placeholder="Search"
                          aria-controls="assessment-table-main"
                          onChange={handleSearchFilter}
                          value={debouncedTerm}
                        />
                      </label>
                      <div className="filter-eff filter-data-btn">
                        <button className="filter-buttons">
                          <i className="fal fa-filter"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="filter-button-group">
                  <div className="button-reset dropdown-comman">
                    <button
                      className="btn btn-primary"
                      title="Reset"
                      onClick={resetFilter}
                    >
                      <i className="fal fa-redo"></i>Reset
                    </button>
                  </div>
                  <div className="files-export-group">
                    <button
                      type="button"
                      className="btn btn-files"
                      onClick={() => {
                        exportXlsxData(
                          `${props.courseName} Grade Book`,
                          props.courseName
                        );
                      }}
                      title="Export spreadsheet"
                    >
                      <i className="fal fa-file-excel icon"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-files"
                      onClick={() => {
                        exportData("csv", `${props.courseName} Grade Book`);
                      }}
                      title="Export CSV"
                    >
                      <i className="fal fa-file-csv icon"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-files"
                      onClick={() => {
                        exportData("pdf", `${props.courseName} Grade Book`);
                      }}
                      title="Export PDF"
                    >
                      <i className="fal fa-file-pdf icon"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="search-filter-div-right">
              <div className=" filter-search-bar-blk">
                <div className="add-ticket-blk button-reset dropdown-comman">
                  <div>
                    <button
                      className="btn btn-primary"
                      title={
                        percentageView ? "Standard View" : "Percentage View"
                      }
                      onClick={() => setPercentageView(!percentageView)}
                    >
                      <i className="fal fa-eye"></i>{" "}
                      {percentageView ? "Standard View" : "Percentage View"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {loading.heading || loading.list ? (
            <SkeletonTicketList />
          ) : userData?.length ? (
            <div className="table-book-responsive">
              <div className="table-book row m-0">
                <div className={"table-book-left "}>
                  <table
                    className={"table-book-main "}
                  >
                    <thead>
                      <tr>
                        <th>Student</th>
                      </tr>
                    </thead>
                    <tbody>
                      {userData.map((userList, index) => (
                        <tr key={index}>
                          <td>
                            <div className="assigned-title-block-new">
                              <div className="assigned-title-itm">
                                <span
                                  className={
                                    "assigned-title-blk  name-icon cat-dark-red " +
                                    ColorRender(userList.role_name)
                                  }
                                >
                                  {userList.picture_me ? (
                                    <img
                                      src={`${IMAGE_URL}/${encodeURI(userList.picture_me
                                        .replace("public/", "")
                                        .replaceAll(
                                          "/home/myaie/public_html/",
                                          ""
                                        ))}`}
                                      alt="AIE"
                                    />
                                  ) : (
                                    InitialRender([
                                      userList.full_name.split(" ")[0],
                                      userList.full_name.split(" ").length
                                        ? userList.full_name.split(" ")[1]
                                        : "",
                                    ])
                                  )}
                                  <span
                                    className={`profile-box-2-status ${userList.activity_status
                                        ? userList.activity_status.toLowerCase() ==
                                          "online"
                                          ? "Online"
                                          : userList.activity_status.toLowerCase() ==
                                            "away"
                                            ? "Away"
                                            : "Offline"
                                        : "Offline"
                                      }`}
                                  >
                                    <i className="fas fa-circle"></i>
                                  </span>
                                  <Hover
                                    firstName={userList.full_name.split(" ")[0]}
                                    lastName={
                                      userList.full_name.split(" ").length
                                        ? userList.full_name.split(" ")[1]
                                        : ""
                                    }
                                    photo={userList.picture_me}
                                    email={userList.email}
                                    mobile={userList.mobile}
                                    status={userList.status}
                                    activity_status={userList.activity_status}
                                    showNumber={true}
                                    number={userList.student_crm_id}
                                    right={true}
                                  />
                                </span>
                                <PermissionsGate
                                  scopes={["casvview"]}
                                  RenderError={() => (
                                    <p title={userList.full_name}>
                                      {userList.full_name}
                                    </p>
                                  )}
                                >
                                  <Link
                                    className="as-text-blue curser "
                                    to={`/studentAdministration/students/open/${userList.student_id}/gradebook`}
                                  >
                                    <span className="" title={userList.full_name}>
                                      {userList.full_name}
                                    </span>
                                  </Link>
                                </PermissionsGate>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div
                  className={
                    "table-book-mid " +
                    (percentageView
                      ? assessmentHeader?.length < 9
                        ? "less-items"
                        : "overflow-auto"
                      : assessmentHeader?.length < 9
                        ? "less-items"
                        : "overflow-auto")
                  }
                >
                  <div className="grade-acc">
                    <div className={"grade-acc-in active"}>
                      <table className="table-book-main table-book-main-contetn">
                        <thead>
                          <tr>
                            {assessmentHeader?.length
                              ? assessmentHeader.map((item, index) => (
                                <th key={index}>
                                  <div className="tb-book-tit">
                                    <Link
                                      className="curser"
                                      to={`/courseAdministration/coursesdetails/${id}/assessments/open/assigned/Details/${item?.id}`}
                                      title={item?.name}
                                    >
                                      <p>
                                        {excludeEmpty == '1' ? <span
                                          href="#"
                                          className="exclude-box mr-1"
                                          data-toggle="tooltip"
                                          title={item?.notify_assessed ? 'Marks included in calculation (Exclude empty grades enabled)' : 'Marks excluded from calculation (Exclude empty grades enabled)'}
                                        >
                                          <i className={`exclude-icons fa-solid ${item?.notify_assessed ? 'fa-check-circle' : 'fa-times-circle'}`}></i>
                                        </span> : null}

                                        {userData[0]?.assessmentArr[index]
                                          ?.pass_required ? (
                                          <span
                                            href="#"
                                            className=" grade-info-red mr-1"
                                            data-toggle="tooltip"
                                            title={"Pass Required"}
                                          >
                                            <i className="fal fa-exclamation-circle"></i>
                                          </span>
                                        ) : (
                                          ""
                                        )}

                                        {TrimText(item?.name, 20)}
                                      </p>
                                    </Link>
                                  </div>
                                </th>
                              ))
                                : (<th>
                                  <div className="tb-book-tit"></div>
                                </th>)}
                          </tr>
                        </thead>
                        <tbody>
                          {userData.map((item, i) => (
                            <tr key={i}>
                              {item?.assessmentArr?.length > 0 ? item.assessmentArr.map((ass, index) => {
                                return (
                                  <td
                                    key={index}
                                    className={
                                      ass?.grant_exemption && ass?.grading_type != 4 ? `exempted-td ${(item.isSupplementary && !ass.isSupplementaryForThisStudent) ? "supplementry-opacity" : ""}` : (ass?.ass_type == 8 && !ass.isSupplementaryForThisStudent) ? "supplement-td" : ""
                                    }
                                  >
                                    {ass?.grant_exemption && ass?.grading_type != 4 ? (
                                      <>
                                        <div
                                          className={`as-widget-text grade-info-plus mt-2 curser ${(item.isSupplementary && !ass.isSupplementaryForThisStudent) ? "supplementry-pointer-events" : ""}`}
                                          title="Remove from Exemption"
                                          onClick={() =>
                                            handleExemption(
                                              ass?.assessment_id,
                                              item?.student_id,
                                              ass?.grant_exemption ? 0 : 1,
                                              ass?.grading_type,
                                              percentageView
                                              ? ass?.is_marked == 1 ? ass.ass_percentage : ''
                                              : ass.grading_type == 0 || ass.grading_type == 3
                                              ? ass?.is_marked == 1 ? ass.ass_mark : ''
                                              : ass.grading_type == 2
                                              ? ass?.is_marked == 1 ? ass.grade : ''
                                              : ass.grading_type == 1
                                              ? ass?.is_marked == 1 ? ass?.grade == 0 ? "0" : ass?.grade > 0 && ass?.grade <= 49 ? '49' : "100" : "" : ''
                                            )
                                          }
                                        >
                                          {ass?.grant_exemption ? (
                                            <i className="fal fa-user-plus"></i>
                                          ) : (
                                            <i className="fal fa-user-plus"></i>
                                          )}
                                          <div
                                            title="Exempted"
                                            className="exempted-text"
                                          >
                                            Exempted{" "}
                                            <i className="fal fa-info-circle"></i>
                                          </div>
                                        </div>
                                      </>
                                    ) : (ass?.ass_type == 8 && !ass.isSupplementaryForThisStudent) ? (
                                      <div className="as-widget-text mt-2 supplement-margin d-flex">N/A</div>
                                    ) : (ass?.ass_type == 9 && !ass.isAssignedSickStudent) ? (
                                      <div className={`as-widget-text mt-2 supplement-margin d-flex ${(item.isSupplementary && !ass.isSupplementaryForThisStudent) ? "supplementry-opacity" : ""}`}>N/A</div>
                                    ) : ass?.grading_type == 4 ? (
                                      <div className="as-widget-text mt-2 supplement-margin d-flex">N/A</div>
                                    ): (
                                      <div className={`d-flex ${(item.isSupplementary && !ass.isSupplementaryForThisStudent) || ass.isSickForThisStudent  ? "supplementry-opacity" : ""}`}>
                                        <div className="marks-number-info">
                                          <div className="marks-input-text">
                                            {percentageView ? (
                                              <div className="resultstatus_flex">
                                                <div className="form-icon-group status-select-form">
                                                  <input
                                                    className={isAssessmentPending(ass) || (ass.is_marked == 1 && ass.ass_percentage == "0") ? "input-red" : ass.is_marked == 0 ? "input-yellow" : "" }
                                                    type="number"
                                                    value={isAssessmentPending(ass) ? 0 : ass.is_marked == 1 ? ass.ass_percentage : ""}
                                                    style={{ minWidth: "40px" }}
                                                    disabled
                                                  />{" "}
                                                  %
                                                </div>
                                              </div>
                                            ) : ass.grading_type == 0 ? (
                                              <div className={`resultstatus_flex`}>
                                                <div className="form-icon-group status-select-form percentage-box">
                                                  <PermissionsGate
                                                    scopes={["cagbedit"]}
                                                    errorProps={{
                                                      disabled: true,
                                                    }}
                                                  >
                                                    <input
                                                      className={ `${isAssessmentPending(ass) || (ass.is_marked == 1 && ass.ass_percentage == "0") ? "input-red" : ass.is_marked == 0 ? "input-yellow" : ""}` }
                                                      type="number"
                                                      onKeyDown={(e) => {
                                                        // Block +, -, and other non-numeric keys (allow numbers, decimal, backspace, delete, arrows)
                                                        if (isBlockedNumericKey(e.key) || e.key === "ArrowUp" || e.key === "ArrowDown" ) {
                                                          e.preventDefault();
                                                        }
                                                      }}
                                                      style={{ minWidth: "40px" }}
                                                      defaultValue={isAssessmentPending(ass) ? 0 : ass.is_marked == 1 ? ass.ass_mark : ""}
                                                      onBlur={(e) => {
                                                        handleUpdateMarks(
                                                          item.student_id,
                                                          ass.assessment_id,
                                                          0,
                                                          e?.target?.value,
                                                          ass.ass_total_mark
                                                        );
                                                      }}
                                                      disabled={(ass.lock_grades == "1" && (!item.isSupplementary || ass.notify_assessed)) || (item.isSupplementary && !ass.isSupplementaryForThisStudent) || ass.isSickForThisStudent}
                                                      onMouseUp={(e) =>
                                                        setOldValue(
                                                          e.target.value
                                                        )
                                                      }
                                                      onWheel={(e) => {
                                                        e.currentTarget.blur();
                                                      }}
                                                    />
                                                  </PermissionsGate>
                                                  {
                                                    <span className="ml-0">
                                                      <span className="ml-0">/ {ass.ass_total_mark}</span>
                                                    </span>
                                                  }
                                                  <span className="percentage">{`| ${ass.ass_percentage}`}%</span>
                                                </div>
                                              </div>
                                            ) : ass.grading_type == 1 ? (
                                              <div className="form-icon-group marks-input-text">
                                                <PermissionsGate
                                                  scopes={["cagbedit"]}
                                                  errorProps={{
                                                    disabled: true,
                                                  }}
                                                >
                                                  <select
                                                    className={`mid-scroll-custom-table-select ${isAssessmentPending(ass) || ass.ass_percentage == "0" ? "percentage-select-red" : ""} ${ass.is_marked == 0 ? "percentage-select-yellow" : ""}`}
                                                    defaultValue={isAssessmentPending(ass) ? 0 : ass?.is_marked == 1 ? ass?.grade == 0 ? "0" : ass?.grade > 0 && ass?.grade <= 49 ? '49' : "100" : ""}
                                                    disabled={
                                                      (ass.lock_grades == "1" && (!item.isSupplementary || ass.notify_assessed)) || (item.isSupplementary && !ass.isSupplementaryForThisStudent) || ass.isSickForThisStudent
                                                    }
                                                    onChange={(e) => {
                                                      handleUpdateMarks(
                                                        item.student_id,
                                                        ass.assessment_id,
                                                        1,
                                                        e?.target?.value,
                                                        ass.ass_total_mark
                                                      );
                                                    }}
                                                    onMouseUp={(e) =>
                                                      setOldValue(
                                                        e.target.value
                                                      )
                                                    }
                                                  >
                                                    {options?.length
                                                      ? options.map(
                                                        (opt, index) => (
                                                          <option
                                                            key={index}
                                                            value={opt.value}
                                                          >
                                                            {opt.label}
                                                          </option>
                                                        )
                                                      )
                                                      : ""}
                                                  </select>
                                                </PermissionsGate>
                                              </div>
                                            ) : ass.grading_type == 2 ? (
                                              <div className="form-icon-group marks-input-text">
                                                <PermissionsGate
                                                  scopes={["cagbedit"]}
                                                  errorProps={{
                                                    disabled: true,
                                                  }}
                                                >
                                                  <select
                                                    className={`mid-scroll-custom-table-select ${isAssessmentPending(ass) || ass.ass_percentage == "0" ? "percentage-select-red" : ""} ${ass.is_marked == 0 ? "percentage-select-yellow" : ""}`}
                                                    defaultValue={isAssessmentPending(ass) ? ass?.letterGrades?.find(g => Number(g.min_score) === 0)?.value ?? "" : ass?.is_marked == 1 ? ass?.grade : ""}
                                                    disabled={
                                                      (ass.lock_grades == "1" && (!item.isSupplementary || ass.notify_assessed)) || (item.isSupplementary && !ass.isSupplementaryForThisStudent) || ass.isSickForThisStudent
                                                    }
                                                    onChange={(e) => {
                                                      handleUpdateMarks(
                                                        item.student_id,
                                                        ass.assessment_id,
                                                        2,
                                                        e?.target?.value,
                                                        ass.ass_total_mark
                                                      );
                                                    }}
                                                    onMouseUp={(e) =>
                                                      setOldValue(
                                                        e.target.value
                                                      )
                                                    }
                                                  >
                                                    {ass?.letterGrades &&
                                                      ass?.letterGrades?.length
                                                      ?  [
                                                        <option key="empty" value=""> </option>,
                                                        ...ass?.letterGrades.map(
                                                          (opt, index) => (
                                                            <option
                                                              key={index}
                                                              value={opt.value}
                                                            >
                                                              {opt.label}
                                                            </option>
                                                          )
                                                        ),
                                                      ]
                                                     : ""}
                                                  </select>
                                                </PermissionsGate>
                                              </div>
                                            ) : (
                                              <div className="resultstatus_flex">
                                                <div className="form-icon-group status-select-form">
                                                  <PermissionsGate
                                                    scopes={["cagbedit"]}
                                                    errorProps={{
                                                      disabled: true,
                                                    }}
                                                  >
                                                    <input
                                                      className={isAssessmentPending(ass) || ass.is_marked == 1 && ass.ass_mark == "0" ? "input-red" : ass.is_marked == 0 ? "input-yellow" : ""}
                                                      style={{ minWidth: "40px" }}
                                                      type="number"
                                                      onKeyDown={(e) => {
                                                        // Block +, -, and other non-numeric keys (allow numbers, decimal, backspace, delete, arrows)
                                                        if (isBlockedNumericKey(e.key) || e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                          e.preventDefault();
                                                        }
                                                      }}
                                                      disabled={
                                                        (ass.lock_grades == "1" && (!item.isSupplementary || ass.notify_assessed)) || (item.isSupplementary && !ass.isSupplementaryForThisStudent) || ass.isSickForThisStudent
                                                      }
                                                      defaultValue={isAssessmentPending(ass) ? 0 : ass.is_marked == 1 ? ass.ass_mark : ""}
                                                      onBlur={(e) => {
                                                        handleUpdateMarks(
                                                          item.student_id,
                                                          ass.assessment_id,
                                                          3,
                                                          e?.target?.value,
                                                          ass.ass_total_mark
                                                        );
                                                      }}
                                                      onMouseUp={(e) =>
                                                        setOldValue(
                                                          e.target.value
                                                        )
                                                      }
                                                      onWheel={(e) => {
                                                        e.currentTarget.blur();
                                                      }}
                                                    />
                                                  </PermissionsGate>
                                                  <span className="ml-0 min-w-40">
                                                    / {ass.ass_total_mark}
                                                  </span>
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                          {ass?.grant_exemption ? (
                                            ""
                                          ) : (
                                            <div className="grade-info-ic-box">
                                              {ass?.mark_edited != "0" ? (
                                                <div
                                                className="grade-info-ic grade-info-orange"
                                                title="Mark Edited"
                                             >
                                                 <i className="fal fa-edit"></i>
                                                </div>
                                              ) : (ass?.assessmentMarkingStatus == "notsubmitted" || ass?.assessmentMarkingStatus == "NOT SUBMITTED") ?
                                                (
                                                  <div
                                                    className="grade-info-ic grade-info-red"
                                                    title="Not Submitted"
                                                  >
                                                    <i className="fal fa-file-times"></i>
                                                  </div>
                                                ) : (
                                                  ""
                                                )}

                                              {ass?.assessmentStatus?.toString() ===
                                                "OPEN" ? (
                                                <div
                                                  className="grade-info-ic grade-info-green"
                                                  title="Open/Extension"
                                                >
                                                  <i className="fal fa-calendar-day"></i>
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                              {ass?.assessmentStatus?.toString() ===
                                                "PENDING" ? (
                                                <div
                                                  className="grade-info-ic grade-info-blue"
                                                  title="Upcoming Assessment"
                                                >
                                                  <i className="fal fa-calendar-alt"></i>
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                            </div>
                                          )}
                                        </div>
                                        <div className="as-widget-outer text-center ml-3 mt-2 d-flex">
                                          {ass.return && ass.return.length > 0 && (
                                            <i className="fal fa-file-download mr-1" style={{ color: 'blue', cursor: 'pointer' }}
                                              onClick={() => handleDownloadMarkerFiles(item.student_id, ass.assessment_id)}
                                              title="Download marker files"
                                            ></i>
                                          )}
                                          <div className="d-flex flex-column">
                                          {(ass?.notify_assessed || ass?.assessmentMarkingStatus?.toString() !==
                                            "NOT SUBMITTED") &&
                                            ass.ass_total_mark
                                            ? RenderQuizAttemptResultStatus(
                                              ass.pass_status
                                            ).html
                                            : ""}
                                          <PermissionsGate
                                            scopes={["coursegge"]}
                                            RenderError={() => (
                                                <div
                                                  className="as-widget-text grade-info-red mt-2"
                                                  title="Grant Exemption"
                                                >
                                                  {ass?.grant_exemption ? (
                                                    <i className="fal fa-user-times"></i>
                                                  ) : (
                                                    <i className="fal fa-user-times"></i>
                                                  )}
                                                </div>
                                              )}
                                            >
                                              <div
                                                className={`as-widget-text mt-1 ${(ass.lock_grades == "1" || (item.isSupplementary && !ass.isSupplementaryForThisStudent) || ass.isSickForThisStudent) && "disabled-select"} grade-info-red curser ${item.isSupplementary ? "supplementry-opacity" : ""} ${(item.isSupplementary && !ass.isSupplementaryForThisStudent) || item.isSupplementary ? "supplementry-pointer-events" : ""}`}
                                                title="Grant Exemption"
                                                disabled={ass.lock_grades == "1" || (item.isSupplementary && !ass.isSupplementaryForThisStudent) || ass.isSickForThisStudent}
                                                onClick={() => {
                                                if(ass.lock_grades == "1" || (item.isSupplementary && !ass.isSupplementaryForThisStudent) || ass.isSickForThisStudent){
                                                    return false;
                                                  }
                                                  return handleExemption(
                                                    ass?.assessment_id,
                                                    item?.student_id,
                                                    ass?.grant_exemption ? 0 : 1,
                                                    ass?.grading_type,
                                                    percentageView
                                                      ? ass?.is_marked == 1 ? ass.ass_percentage : ''
                                                      : ass.grading_type == 0 || ass.grading_type == 3
                                                        ? ass?.is_marked == 1 ? ass.ass_mark : ''
                                                        : ass.grading_type == 2
                                                          ? ass?.is_marked == 1 ? ass.grade : ''
                                                          : ass.grading_type == 1
                                                            ? ass?.is_marked == 1 ? ass?.grade == 0 ? "0" : ass?.grade > 0 && ass?.grade <= 49 ? '49' : "100" : "" : ''
                                                    , ass.is_marked
                                                  )
                                                }
                                                }
                                              >
                                                {ass?.grant_exemption ? (
                                                  <i className="fal fa-user-times"></i>
                                                ) : (
                                                  <i className="fal fa-user-times"></i>
                                                )}
                                              </div>
                                            </PermissionsGate>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </td>
                                );
                              }) : <td></td>}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div
                  className={
                    "table-book-right " +
                    (percentageView
                      ? assessmentHeader?.length < 9
                        ? "many-items"
                        : "max-width-fit-content"
                      : assessmentHeader?.length < 9
                        ? "many-items"
                        : "max-width-fit-content")
                  }
                >
                  <table
                    className={"table-book-main text-center"}
                  >
                    <thead>
                      <tr>
                        <th className="second-last-cell  pr-1">
                          <div className="tb-book-tit">
                            Course Grade
                            <span
                              className=" grade-info-red"
                              data-toggle="tooltip"
                              title={
                                tooltipValues.passReqAssessment.length
                                  ? `Required pass mark on ${tooltipValues.passReqAssessment.toString()} and a final grade above ${tooltipValues?.requiredPassMarkforCourse
                                  }`
                                  : `Requires a final grade above ${tooltipValues?.requiredPassMarkforCourse}`
                              }
                            >
                              <i className="fal fa-exclamation-circle pl-1"></i>
                            </span>
                          </div>
                        </th>
                        <th>
                          <div className="tb-book-tit text-left">Actions</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {userData.map((item, index) => (
                        <tr key={index}>
                          <td className="pr-2">
                            {item?.pass_status == "N/A" &&
                              (item?.scoreRecieved != "N/A" ||
                                !item?.gradeText) ? (
                              <div className="as-widget-outer text-center">
                                N/A
                              </div>
                            ) : (
                              <div className="as-widget-outer text-center">
                                {item?.pass_status == "N/A"
                                  ? "N/A"
                                  : RenderQuizAttemptResultStatus(item?.pass_status).html}
                                <div className="as-widget-text mt-1">
                                  {percentageView
                                    ? (item?.scoreRecieved &&
                                      item?.scoreRecieved != "N/A") ||
                                      item?.scoreRecieved === 0
                                      ? typeof item?.scoreRecieved ==
                                        "string" &&
                                        item?.scoreRecieved.includes("%")
                                        ? Math.round(
                                          parseFloat(
                                            item?.scoreRecieved.replace(
                                              "%",
                                              ""
                                            )
                                          )
                                        ).toString() + "%"
                                        : typeof item?.scoreRecieved ==
                                          "string" &&
                                          !item?.scoreRecieved.includes("%")
                                          ? Math.round(
                                            parseFloat(item?.scoreRecieved)
                                          ).toString() + "%"
                                          : typeof item?.scoreRecieved ===
                                            "number"
                                            ? item?.scoreRecieved + "%"
                                            : item?.scoreRecieved
                                              ? item?.scoreRecieved
                                              : "N/A"
                                      : "N/A"
                                    : item.grading_type != 3
                                      ? typeof item?.gradeText == "string" &&
                                        item?.gradeText.includes("%")
                                        ? Math.round(
                                          parseFloat(
                                            item?.gradeText.replace("%", "")
                                          )
                                        ).toString() + "%"
                                        : typeof item?.gradeText === "number"
                                          ? item?.gradeText + "%"
                                          : item?.gradeText
                                            ? item?.gradeText
                                            : "N/A"
                                      : twoDecimalRound(item?.getAssessmentCalculate_sum_ass_mark) +
                                      " / " +
                                      item.getAssessmentCalculate_sum_ass_total_mark}
                                </div>
                              </div>
                            )}
                          </td>
                          <td className="justify-content-end d-flex calendar-cart-item-inner">
                            <div className="assessment-08 btn-dropdown-grp">
                              <div className="as-buttons d-flex">
                                <PermissionsGate
                                  scopes={["casvview"]}
                                  RenderError={() => (
                                    <button
                                      disabled
                                      className="btn btn-primary rounded-circle"
                                      title="Open"
                                    >
                                      <i className="fal fa-folder-open"></i>
                                    </button>
                                  )}
                                >
                                  <Link
                                    className="btn btn-primary rounded-circle"
                                    title="Open"
                                    to={`/studentAdministration/students/open/${item.student_id}/gradebook`}
                                    target="_blank"
                                  >
                                    <i className="fal fa-folder-open"></i>
                                  </Link>
                                </PermissionsGate>
                                <PermissionsGate
                                  scopes={["casvview"]}
                                  RenderError={() => (
                                    <button
                                      disabled
                                      className="btn btn-primary rounded-circle"
                                      title="Save Grades"
                                    >
                                      <i className="fal fa-save"></i>
                                    </button>
                                  )}
                                >
                                  <button
                                    className="btn btn-primary rounded-circle"
                                    title="Save Grades"
                                    disabled={item?.isDis}
                                    onClick={
                                      () =>
                                        handleSaveSingleGrade(item?.student_id)
                                    }
                                  >
                                    <i className="fal fa-save"></i>
                                  </button>
                                </PermissionsGate>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          ) : (
            <div className="custom-table-msg">{Str.noRecord}</div>
          )}
          <nav className="pagination-nav">
            <div>
              {errorMessage ? (
                <div className="invalid-feedback d-block">{errorMessage}</div>
              ) : (
                ""
              )}
            </div>
            <div className="second-child">
              <span>Rows per page:&nbsp;</span>
              <div className="pagination-select">
                <select
                  defaultValue={tableState?.limit}
                  onChange={(e) => {
                    let value = e?.target?.value;
                    setTableState((prevState) => ({
                      ...prevState,
                      limit: value ? value : 10,
                      page: 1,
                    }));
                  }}
                >
                  {TABLE_ROWS_PER_PAGE.map((page, index) => (
                    <option key={index}>{page}</option>
                  ))}
                </select>
              </div>
              <span className="mx-3">
                {getPaginationRange()} of {paginationState.total}
              </span>
              <div className="pagination-btns">
                <button
                  type="button"
                  disabled={paginationState.currentPage <= 1}
                  onClick={() => {
                    if (updateValueArr?.length) {
                      handleNavigation(null, "firstPage");
                    } else {
                      setTableState(prev => ({ ...prev, page: 1 }));
                    }
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z" />
                    <path fill="none" d="M24 24H0V0h24v24z" />
                  </svg>
                </button>

                {/* Previous Page Button */}
                <button
                  type="button"
                  disabled={paginationState.currentPage <= 1}
                  onClick={() => {
                    if (updateValueArr?.length) {
                      handleNavigation(null, "prevPage");
                    } else {
                      setTableState(prev => ({ ...prev, page: paginationState.currentPage - 1}));
                    }
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                    <path d="M0 0h24v24H0z" fill="none" />
                  </svg>
                </button>

                {/* Next Page Button */}
                <button
                  type="button"
                  disabled={paginationState.currentPage == paginationState.lastPage}
                  onClick={() => {
                    if (updateValueArr?.length) {
                      handleNavigation(null, "nextPage");
                    } else {
                      setTableState(prev => ({ ...prev, page: paginationState.currentPage + 1 }));
                    }
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                    <path d="M0 0h24v24H0z" fill="none" />
                  </svg>
                </button>

                {/* Last Page Button */}
                <button
                  type="button"
                  disabled={paginationState.currentPage == paginationState.lastPage}
                  onClick={() => {
                    if (updateValueArr?.length) {
                      handleNavigation(null, "lastPage");
                    } else {
                      setTableState(prev => ({ ...prev, page: paginationState.lastPage }));
                    }
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z" />
                    <path fill="none" d="M0 0h24v24H0V0z" />
                  </svg>
                </button>
              </div>
            </div>
          </nav>
        </div>
        {userData?.length && (updateValueArr.length || Number(isCourseEdited)) ? (
          <GradeBookSaveBar
            handleClick={() => handleSaveGrades()}
            disabled={errorMessage}
            saveGradesLoading={saveGradesLoading}
          />
        ) : null}
      </div>
    </>
  );
}

export default CourseGradeBook;
